module.exports = __webpack_public_path__ + "img/company-icon.e5ae6cc6.svg";